module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_v_grey.ce20a8d7.png";